// Product cards: play the product video while a mouse hovers the card (snippets/card-product.liquid).
// Touch devices and prefers-reduced-motion never play; the hero image stays.
(() => {
  const canHover = matchMedia('(hover: hover) and (pointer: fine)');
  const calm = matchMedia('(prefers-reduced-motion: reduce)');
  let current = null;
  const stop = (v) => {
    v.classList.remove('is-playing');
    v.pause();
    v.currentTime = 0;
  };
  const hover = (v) => {
    if (v === current) return;
    if (current) stop(current);
    current = v;
    if (!v || !canHover.matches || calm.matches) return;
    v.play().then(() => { if (current === v) v.classList.add('is-playing'); }).catch(() => {});
  };
  document.addEventListener('mouseover', (e) => {
    const card = e.target.closest && e.target.closest('.card-wrapper');
    hover(card ? card.querySelector('video.card-hover-video') : null);
  });
  document.documentElement.addEventListener('mouseleave', () => hover(null));
})();
